import moment from "moment-timezone";
export const transformSchemaForGps = (pdcsList = []) => {
  const gpsPdcsList = pdcsList.map(pdc => ({
    ...pdc,
    gps_lat: parseFloat(pdc.gps_lat) || parseFloat(pdc.adresse.gpsLat),
    gps_long: parseFloat(pdc.gps_long) || parseFloat(pdc.adresse.gpsLong)
  }));

  return gpsPdcsList;
};
export const sortEventsbyDate = (eventsList = []) => {
  let sortedEvents = [...eventsList];
  if (sortedEvents && Array.isArray(sortedEvents))
    sortedEvents = sortedEvents
      .filter(x => x)
      .sort((a, b) => {
        return moment(a.start_date).valueOf() - moment(b.start_date).valueOf();
      });
  return sortedEvents;
};

export const get = (path, object, defaultValue = null) =>
  path.reduce((xs, x) => (xs && xs.hasOwnProperty(x) ? xs[x] : defaultValue), object);

export const computeFiltersValues = (userPdcsList, departmentNb, frequencyId, retailersId, cipId) => {
  const listAvailableDepartments = [
    ...new Set(
      userPdcsList.map(pdc => {
        let pdcZipCode = get(["adresse", "cp"], pdc);
        let pdcDepartmentNb = pdcZipCode
          ? pdcZipCode.toString().slice(0, -3) //version hors pharma
          : pdc.department; // version pharma
        return pdcDepartmentNb;
      })
    )
  ];

  const listAvailableRetailers = [];
  userPdcsList.forEach(pdc => {
    let pdcZipCode = get(["adresse", "cp"], pdc);
    let pdcDepartmentNb = pdcZipCode
      ? pdcZipCode.toString().slice(0, -3) //version hors pharma
      : pdc.department; // version pharma

    if (
      !listAvailableRetailers.find(retailer => retailer.id === pdc.retailer_id) &&
      (departmentNb === null || departmentNb === undefined || departmentNb == pdcDepartmentNb) &&
      (frequencyId === null || frequencyId === undefined || frequencyId === pdc.frequency) &&
      (cipId === null || cipId === undefined || cipId === pdc.cip)
    ) {
      listAvailableRetailers.push({
        id: pdc.retailer_id,
        label: pdc.retailer_label
      });
    }
  });
  const listAvailableFrequencies = [];
  userPdcsList.forEach(pdc => {
    let pdcZipCode = get(["adresse", "cp"], pdc);
    let pdcDepartmentNb = pdcZipCode
      ? pdcZipCode.toString().slice(0, -3) //version hors pharma
      : pdc.department; // version pharma

    if (
      !listAvailableFrequencies.find(frequency => frequency.id === pdc.frequency) &&
      (departmentNb === null || departmentNb === undefined || departmentNb == pdcDepartmentNb) &&
      (cipId === null || cipId === undefined || cipId === pdc.cip) &&
      (retailersId.length === 0 || retailersId.indexOf(pdc.retailer_id) > -1)
    ) {
      listAvailableFrequencies.push({
        id: pdc.frequency,
        label: pdc.frequency
      });
    }
  });
  const listAvailableCips = [];
  userPdcsList.forEach(pdc => {
    let pdcZipCode = get(["adresse", "cp"], pdc);
    let pdcDepartmentNb = pdcZipCode
      ? pdcZipCode.toString().slice(0, -3) //version hors pharma
      : pdc.department; // version pharma

    if (
      !listAvailableCips.find(cip => cip.id === pdc.cip) &&
      (departmentNb === null || departmentNb === undefined || departmentNb == pdcDepartmentNb) &&
      (frequencyId === null || frequencyId === undefined || frequencyId === pdc.frequency) &&
      (retailersId.length === 0 || retailersId.indexOf(pdc.retailer_id) > -1)
    ) {
      listAvailableCips.push({
        id: pdc.cip,
        label: pdc.cip
      });
    }
  });

  return {
    listAvailableDepartments,
    listAvailableRetailers,
    listAvailableFrequencies,
    listAvailableCips
  };
};



// WEBPACK FOOTER //
// src/containers/activite/map/map.utils.js